import { every, isEmpty } from 'lodash';
import { UtmData } from './store';

export const CTA_MOBILE_URL = 'https://brigit.app.link/6zaZ4kdzsT';

enum WebAppUrl {
  STAGING = 'staging-app.hellobrigit.com',
  PRODUCTION = 'app.hellobrigit.com',
  DEV = 'localhost',
}

/**
 * Get the proper app url to navigate to depending on the current
 * site ex. hellobrigit.com -> app.hellobrigit.com; staging-site.* -> staging-app.*
 *
 * This also constructs a URL where the query params are passed through
 *
 * @param path the sub path to navigate to. ex. if `login` is passed in, and we're on
 *             prod, it would navigate to https://hellobrigit.com/login?some=query&params=here
 */
export const getWebAppUrl = (path?: string) => {
  let normalizedPath = path;
  if (path && !path.startsWith('/')) {
    normalizedPath = `/${path}`;
  }

  const { hostname, search } = window.location;
  let newHost;
  if (hostname.match('^localhost') || hostname.match('^staging.*brigit.com$')) {
    // if host starsts with local host OR starts with staging and ends in brigit.com... return staging
    newHost = WebAppUrl.STAGING;
  } else if (hostname.match('brigit.com$')) {
    // if hostname ends with brigit.com but does not fall in above, return prod
    newHost = WebAppUrl.PRODUCTION;
  } else {
    throw new Error('Not in a supported brigit site environment.');
  }

  return `https://${newHost}${normalizedPath || ''}${search}`;
};

/**
 * Takes the query string from the URL (window.location.search) and parses for attribution params to return.
 * @param qs value from window.location.search
 *
 * todo: this is copied from brigit-web....should probably investigate common library sharing
 */
export const getAttributionParamsFromQueryString = (qs: string): UtmData | undefined => {
  const urlParams = new URLSearchParams(qs);
  let params: UtmData = {
    campaignName:
      urlParams.get('sourceCampaign') || urlParams.get('utm_campaign') || urlParams.get('c'),
    campaignMedium:
      urlParams.get('sourceAdType') || urlParams.get('utm_medium') || urlParams.get('af_ad_type'),
    campaignSource:
      urlParams.get('sourceChannel') || urlParams.get('utm_source') || urlParams.get('af_channel'),
    campaignContent:
      urlParams.get('sourceAdGroup') || urlParams.get('utm_content') || urlParams.get('af_adset'),
    campaignTerm:
      urlParams.get('sourceKeywords') || urlParams.get('utm_term') || urlParams.get('af_keywords'),
    irclickid: urlParams.get('irclickid'),
  };

  if (every(params, isEmpty)) {
    params = undefined;
  }
  return params;
};

export const isOnMobileDevice = () => {
  // credit to Timothy Huang for this regex test:
  // https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
};
